import React from 'react';

import Grid from '@material-ui/core/Grid';

function Force() {
  return (
    <Grid justify="center" container>
      <span className="h3Style">Força</span>
    </Grid>
  );
}

export default Force;
